import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';
import DiagramDisplay from './DiagramDisplay';

export default withI18n()(withRouter(DiagramDisplay));
